import { useEffect } from "react";

/**
 * Custom hook for handling outside click events.
 * Closes dropdown when clicking outside the referenced element.
 */
export default function useOutsideClick(ref, handler, active) {
  useEffect(() => {
    if (!active) return;
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, [ref, handler, active]);
}
